import { getterTypes } from '@/core/constants'

function getCountSelecionados(state) {
	if (state.itensParaAdicionarNaAta) return state.itensParaAdicionarNaAta.length
	return 0
}

function getItensAgrupadosPorFornecedorId(array) {
	return array.reduce((acc, item) => {
		const fornecedor = acc.find((elem) => elem.idFornecedor === item.idFornecedor)
		if (!fornecedor) {
			acc.push({
				idFornecedor: item.idFornecedor,
				idLotes: [...item.idLotes].sort(sortAsc),
				numeroEditais: [item.numeroEdital],
				idItensNaoAdicionados: item.idItensNaoAdicionados.map((item) => item.id),
			})
		} else {
			fornecedor.idLotes = [...fornecedor.idLotes, ...item.idLotes].sort(sortAsc)
			fornecedor.numeroEditais.push(item.numeroEdital)
		}
		return acc
	}, [])
}

function sortAsc(a, b) {
	return a - b
}

export default {
	[getterTypes.ITEM_ATA.IS_TEM_ITEM_SELECIONADO](state) {
		return getCountSelecionados(state) > 0
	},

	[getterTypes.ITEM_ATA.ITENS_SELECIONADOS_COUNT](state) {
		return getCountSelecionados(state)
	},
	[getterTypes.ITEM_ATA.IS_SELECIONADO]: (state) => (item) => {
		let selecionado = state.itensParaAdicionarNaAta.filter(
			(sel) =>
				sel.idProcesso === item.idProcesso &&
				sel.idFornecedor === item.idFornecedor &&
				sel.editais &&
				sel.editais.filter((edital) => edital.numeroEdital === item.numeroEdital).length > 0,
		)

		return selecionado.length > 0
	},

	[getterTypes.ITEM_ATA.ITENS_PARA_INSERIR_NA_ATA]: (state) => (idAta) => {
		const itens = getItensAgrupadosPorFornecedorId(state.itensParaAdicionarNaAta)
		return { idAta: idAta, itens: itens, gerandoAta: true }
	},

	[getterTypes.ITEM_ATA.ITENS_PARA_EXCLUIR]: (state) => {
		const idsParaExcluir = state.itensParaExcluir.map((value) => {
			return value.id
		})

		return { ids: idsParaExcluir }
	},

	[getterTypes.ITEM_ATA.IS_NAO_ADICIONADO]: (state) => (item) => {
		let retorno = false
		state.itensParaAdicionarNaAta.forEach((itemAta) => {
			let itemNaoAdicionado = itemAta.idItensNaoAdicionados.filter(
				(naoAdicionado) => naoAdicionado.id === item.id,
			)
			if (itemNaoAdicionado.length > 0) retorno = true
		})

		return retorno
	},
	[getterTypes.ITEM_ATA.EXISTE_TODOS_HISTORICOS_ITEM](state) {
		const valores = Object.values(state.existeHistorico)
		return valores.every((valor) => valor === true)
	},
	[getterTypes.ITEM_ATA.EXISTE_HISTORICO_REALINHAMENTO](state) {
		return state.existeHistorico.acessoHistoricoRealinhar
	},
	[getterTypes.ITEM_ATA.EXISTE_HISTORICO_BLOQUEIO](state) {
		return state.existeHistorico.acessoHistoricoBloquearDesbloquear
	},
	[getterTypes.ITEM_ATA.EXISTE_HISTORICO_ALTERAR_CLASSIFICACAO](state) {
		return state.existeHistorico.acessoHistoricoAlterarClassificacao
	},
	[getterTypes.ITEM_ATA.EXISTE_HISTORICO_ALTERAR_FORNECEDOR](state) {
		return state.existeHistorico.acessoHistoricoAlterarFornecedor
	},
	[getterTypes.ITEM_ATA.EXISTE_HISTORICO_GERENCIAR_SALDO](state) {
		return state.existeHistorico.acessoHistoricoGerenciarSaldo
	},
}
